/**
 * World 4 — "Storm Summit" (Thunder, levels 31–40). Act I, chapter 4: Vera's
 * unmasking (The Hooded Stranger → Fallen Guardian) and the saga's first
 * GUTTERING trial — Rumble, the Bireon songbird whose song was the summit's thunder,
 * has forgotten its own song. Levels/caps stamped from World 4's band (31→40).
 * Voltaryx is Clan Z's alone (docs/campaign/VILLAIN_ESCALATION.md E14), so the
 * Thunder roster is Zaricat/Toro plus the Tale's hero Bireon; variety is carried by
 * archetype, nickname, and the opponent ramp. Finale boss (slot 0) is Bireon.
 */

import {
  node,
  giftNode,
  giftTracks,
  giftXp,
  rival,
  CAMPAIGN_XP_NORMAL,
  CAMPAIGN_XP_MINI_BOSS,
  CAMPAIGN_XP_ZONE_BOSS,
  ZARICAT,
  TORO,
  TALION,
  PEFAREON,
  SUMIYA,
  BIREON,
  type CampaignWorld,
  TRIXON,
} from './builders.js';
import { GIFT_SKILL_SUIKA } from '../cardShopConfig.js';
import {
  WORLD4_NODE_STORIES as S,
  WORLD4_ZONE_STORIES as Z,
  WORLD4_TAGLINE,
} from './stories/world4.js';

export const WORLD_4: CampaignWorld = {
  worldId: 'w4',
  name: 'Storm Summit',
  element: 'Thunder',
  featuredSpeciesId: BIREON,
  story: WORLD4_TAGLINE,
  locked: true,
  zones: [
    {
      zoneId: 'z9',
      name: 'Thunder Steps',
      element: 'Thunder',
      story: Z['z9'],
      nodes: [
        node({
          nodeId: 'z9-n1',
          kind: 'normal',
          rivalName: 'Timmy',
          rivalTitle: 'Youngster',
          ...S['z9-n1'],
          squad: [rival(ZARICAT, 'Jolt'), rival(TRIXON, 'Flicker'), rival(TORO, 'Stomp')],
          opponentCount: 1,
          xpReward: CAMPAIGN_XP_NORMAL,
          portraitSpeciesId: ZARICAT,
        }),
        giftNode({
          nodeId: 'z9-g1',
          giver: 'Storm Watch',
          label: 'Trailside Gift',
          story: 'A watcher scanning the racing clouds turns as you climb up.',
          line: 'You climbed far. These Soul Shards are yours!',
          reward: { tracks: giftTracks(BIREON) },
          portraitSpeciesId: BIREON,
        }),
        node({
          nodeId: 'z9-n2',
          kind: 'normal',
          rivalName: 'Mimi',
          rivalTitle: 'Lass',
          ...S['z9-n2'],
          squad: [rival(BIREON, 'Updraft'), rival(ZARICAT, 'Nimbus'), rival(TORO, 'Gust')],
          opponentCount: 1,
          xpReward: CAMPAIGN_XP_NORMAL,
          portraitSpeciesId: BIREON,
        }),
        node({
          nodeId: 'z9-n3',
          kind: 'normal',
          rivalName: 'Lulu',
          rivalTitle: 'Lass',
          ...S['z9-n3'],
          squad: [rival(TORO, 'Charge'), rival(ZARICAT, 'Arc'), rival(BIREON, 'Spark')],
          opponentCount: 1,
          xpReward: CAMPAIGN_XP_NORMAL,
          portraitSpeciesId: TORO,
        }),
        node({
          nodeId: 'z9-n4',
          kind: 'zone_boss',
          rivalName: 'Cliff',
          rivalTitle: 'Bird Keeper',
          ...S['z9-n4'],
          squad: [rival(BIREON, 'Bastion'), rival(TORO, 'Rampart'), rival(ZARICAT, 'Watch')],
          opponentCount: 1,
          xpReward: CAMPAIGN_XP_ZONE_BOSS,
          portraitSpeciesId: BIREON,
        }),
      ],
    },
    {
      zoneId: 'z10',
      name: 'Howling Caves',
      element: 'Thunder',
      story: Z['z10'],
      nodes: [
        node({
          nodeId: 'z10-n1',
          kind: 'normal',
          rivalName: 'Vera',
          rivalTitle: 'Channeler',
          ...S['z10-n1'],
          squad: [rival(ZARICAT, 'Hush'), rival(BIREON, 'Murmur'), rival(TORO, 'Rumble')],
          opponentCount: 2,
          xpReward: CAMPAIGN_XP_NORMAL,
          portraitSpeciesId: ZARICAT,
        }),
        giftNode({
          nodeId: 'z10-g1',
          giver: 'Old Duelist',
          label: 'Training Charm',
          story: 'A duelist coiling a crackling charm sizes you up.',
          line: 'This charm helps a young Suikamon grow. Take it.',
          reward: { xp: giftXp(3) },
          portraitSpeciesId: BIREON,
        }),
        node({
          nodeId: 'z10-n2',
          kind: 'normal',
          rivalName: 'Zip',
          rivalTitle: 'Clan Z',
          ...S['z10-n2'],
          squad: [rival(TALION, 'Dash'), rival(TRIXON, 'Loop'), rival(ZARICAT, 'Roll')],
          opponentCount: 2,
          xpReward: CAMPAIGN_XP_NORMAL,
          portraitSpeciesId: TALION,
        }),
        node({
          nodeId: 'z10-nw1',
          kind: 'normal',
          encounterKind: 'wild',
          rivalName: 'Stormhide',
          rivalTitle: 'Wild Suikamon',
          ...S['z10-nw1'],
          squad: [rival(TORO, 'Charge'), rival(ZARICAT, 'Arc'), rival(BIREON, 'Spark')],
          opponentCount: 2,
          xpReward: CAMPAIGN_XP_NORMAL,
          portraitSpeciesId: TORO,
        }),
        node({
          nodeId: 'z10-n3',
          kind: 'normal',
          rivalName: 'Aggie',
          rivalTitle: 'Medium',
          ...S['z10-n3'],
          squad: [rival(BIREON, 'Cirrus'), rival(ZARICAT, 'Static'), rival(TORO, 'Thunderhead')],
          opponentCount: 2,
          xpReward: CAMPAIGN_XP_NORMAL,
          portraitSpeciesId: BIREON,
        }),
        node({
          nodeId: 'z10-n4',
          kind: 'zone_boss',
          rivalName: 'Vera',
          rivalTitle: 'Channeler',
          ...S['z10-n4'],
          squad: [rival(TORO, 'Augur'), rival(BIREON, 'Oracle'), rival(ZARICAT, 'Omen')],
          opponentCount: 2,
          xpReward: CAMPAIGN_XP_ZONE_BOSS,
          portraitSpeciesId: TORO,
        }),
      ],
    },
    {
      zoneId: 'z11',
      name: 'Storm Crown',
      element: 'Thunder',
      story: Z['z11'],
      nodes: [
        node({
          nodeId: 'z11-n1',
          kind: 'normal',
          rivalName: 'Zap',
          rivalTitle: 'Clan Z',
          ...S['z11-n1'],
          squad: [rival(PEFAREON, 'Shade'), rival(TRIXON, 'Tally'), rival(ZARICAT, 'Bell')],
          opponentCount: 3,
          xpReward: CAMPAIGN_XP_NORMAL,
          portraitSpeciesId: PEFAREON,
        }),
        giftNode({
          nodeId: 'z11-g1',
          giver: 'Shrine Keeper',
          label: 'Soul Token',
          story: 'On the ridge ahead of you, a storm shrine sparks.',
          line: 'The storm leaves a big handful of Soul Shards here. Take them!',
          reward: { tracks: giftTracks(BIREON, true), suika: GIFT_SKILL_SUIKA },
          portraitSpeciesId: BIREON,
        }),
        node({
          nodeId: 'z11-n2',
          kind: 'normal',
          rivalName: 'Timmy',
          rivalTitle: 'Youngster',
          ...S['z11-n2'],
          squad: [rival(ZARICAT, 'Lance'), rival(TORO, 'Maul'), rival(TRIXON, 'Pike')],
          opponentCount: 3,
          xpReward: CAMPAIGN_XP_NORMAL,
          portraitSpeciesId: ZARICAT,
        }),
        node({
          nodeId: 'z11-n3',
          kind: 'mini_boss',
          rivalName: 'Aggie',
          rivalTitle: 'Medium',
          ...S['z11-n3'],
          squad: [rival(BIREON, 'Vigil'), rival(TORO, 'Sentinel'), rival(ZARICAT, 'Ward')],
          opponentCount: 3,
          xpReward: CAMPAIGN_XP_MINI_BOSS,
          portraitSpeciesId: BIREON,
        }),
        node({
          nodeId: 'z11-nw2',
          kind: 'normal',
          encounterKind: 'wild',
          rivalName: 'Thunderhoof',
          rivalTitle: 'Wild Suikamon',
          ...S['z11-nw2'],
          // Pefareon takes slot 0 — a WILD encounter, which the element rule exempts, so it is
          // the one node in this stretch that can break the repeat (N5). Every trainer line-up
          // in the zone, bosses included, stays pure Electric.
          squad: [rival(SUMIYA, 'Jag'), rival(TORO, 'Crash'), rival(BIREON, 'Bolt')],
          opponentCount: 3,
          xpReward: CAMPAIGN_XP_NORMAL,
          portraitSpeciesId: TORO,
        }),
        node({
          nodeId: 'z11-n4',
          kind: 'zone_boss',
          rivalName: 'Rumble',
          rivalTitle: 'Storm Guardian',
          ...S['z11-n4'],
          squad: [rival(BIREON, 'Rumble'), rival(TORO, 'Echo'), rival(ZARICAT, 'Castor')],
          opponentCount: 3,
          xpReward: CAMPAIGN_XP_ZONE_BOSS,
          portraitSpeciesId: BIREON,
          soulSpeciesId: BIREON,
        }),
      ],
    },
  ],
};
